import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ActionDropdown } from '../ActionDropdown/component.js';
import { ActionButtons } from '../ActionButtons/component.js';
var _excluded = ["actions", "dropdownActions", "row"];
var EVALUATE_ATTRIBUTES = Object.freeze({
  className: true,
  disabled: true,
  download: true,
  icon: true,
  iconFamily: true,
  iconTransform: true,
  keyField: true,
  showLabel: true,
  target: true,
  title: true,
  tooltip: true
});
var EVALUATE_ACTION = Object.freeze({
  link: true,
  externalLink: true
});
var MAX_ACTION_BUTTONS = 4;

var Actions = function Actions(props) {
  var _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      dropdownActions = props.dropdownActions,
      row = props.row,
      additionalProps = _objectWithoutProperties(props, _excluded);

  var actionsLength = actions.length;
  var filteredActions = actions.filter(function (action, index) {
    if (typeof action.filter !== 'function') {
      return true;
    }

    return action.filter(row, index);
  }).map(function (action, index) {
    var evaluatedAction = {};
    Object.entries(action).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      evaluatedAction[key] = EVALUATE_ATTRIBUTES[key] && typeof value === 'function' ? value(row, index) : value;
    });

    if (EVALUATE_ACTION[action.actionType] && typeof action.action === 'function') {
      evaluatedAction.action = action.action(row, index);
    }

    return evaluatedAction;
  });

  if (actionsLength > MAX_ACTION_BUTTONS || dropdownActions) {
    return /*#__PURE__*/React.createElement(ActionDropdown, _extends({}, additionalProps, {
      row: row,
      menuItems: filteredActions
    }));
  } else {
    return /*#__PURE__*/React.createElement(ActionButtons, _extends({}, additionalProps, {
      row: row,
      buttons: filteredActions
    }));
  }
};

export { Actions };